import Language from './language';

export default {
  components: { Language },
  // el: 'agent-item',
  props: ['item', 'use_view', "list"],
  methods: {
    detail: function(item) {
        try {
          let version = Number(item.version.replace(/v/, '').replace(/(\.)/gm, '').substring(0, 6));
          if(version < 202207) {
            return this.$router.push(`modules/v1/${item.id}`);
          }

          return this.$router.push(`agent/${item.id}`);

        } catch (e) {

          console.error(e)
          return this.$router.push(`modules/v1/${item.id}`);

        }

    },
  },
  destroyed () { console.log('item.vue destroyed') },
  mounted () { console.log('item.vue mounted') },
}
